import Login from "../pages/Login/Login";
import AuthBody from "../components/common/AuthBody/AuthBody";
import "../App.sass";
import Register from "../pages/Register/Register";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ConnectYourAccounts from "../pages/ConnectYourAccounts/ConnectYourAccounts";
import Base from "../pages/Base";
import TwoFactorAuth from "../pages/TwoFactorAuth/TwoFactorAuth";
import VerifyAccount from "../pages/VerifyAccount/VerifyAccount";
import AccountVerified from "../pages/AccountVerified/AccountVerified";
import hostConfig from "../config/hostConfig";

interface IAuthFrameProps {
    base?: boolean;
    connectyourAccounts?: boolean;
    login?: boolean;
    register?: boolean;
    forgotPassword?: boolean;
    resetPassword?: boolean;
    twofactorauth?: boolean;
    verifyAccount?: boolean;
    accountVerified?: boolean;
}

const AuthFrame = (props: IAuthFrameProps) => {
    const {
        base,
        connectyourAccounts,
        login,
        register,
        forgotPassword,
        resetPassword,
        twofactorauth,
        verifyAccount,
        accountVerified,
    } = props;
    return (
        <div className="loginBodyContainer">
            <div className="carexLogoContainer0">
                <img
                    className="carexLogo"
                    alt="Logo"
                    src={hostConfig.mobileLogo}
                    style={{ minWidth: hostConfig.width }}
                />
                <div className="carexLogoText">The Operating System for Virtual Medicine</div>
            </div>
            <div className="leftSideDiv">
                <AuthBody />
            </div>
            <div className="rightSideDiv">
                {base && <Base />}
                {connectyourAccounts && <ConnectYourAccounts />}
                {login && <Login />}
                {register && <Register />}
                {forgotPassword && <ForgotPassword />}
                {resetPassword && <ResetPassword />}
                {twofactorauth && <TwoFactorAuth />}
                {verifyAccount && <VerifyAccount />}
                {accountVerified && <AccountVerified />}
            </div>
        </div>
    );
};

export default AuthFrame;
